import React from 'react';
import { Eye, FileCheck, MessageSquareText, ArrowRight } from 'lucide-react';

const offerings = [
  {
    icon: Eye,
    title: 'Investigații discrete',
    description: 'Monitorizare, supraveghere foto-video și verificări de context, realizate legal și profesionist.',
    features: ['Supraveghere discretă', 'Tehnologie avansată', '100% Legal'],
    gradient: 'from-blue-500 to-cyan-500'
  },
  {
    icon: FileCheck,
    title: 'Dovezi verificabile',
    description: 'Rapoarte detaliate, înregistrări și materiale foto/video pregătite pentru utilizare juridică dacă e nevoie.',
    features: ['Rapoarte complete', 'Admisibile în instanță', 'Documentație clară'],
    gradient: 'from-amber-500 to-orange-500'
  },
  {
    icon: MessageSquareText,
    title: 'Consultanță confidențială',
    description: 'Analizăm situația, stabilim strategia optimă și îți prezentăm opțiunile, fără presiune.',
    features: ['Fără obligații', 'Discreție totală', 'Suport personalizat'],
    gradient: 'from-green-500 to-emerald-500'
  }
];

const OfferingsSection = () => {
  return (
    <section className="py-12 bg-slate-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-500 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Ce <span className="text-amber-400">oferim:</span>
          </h2>
          <p className="text-slate-300 text-lg md:text-xl max-w-2xl mx-auto">
            Servicii profesionale de investigații private în județul Bacau, adaptate nevoilor tale specifice.
          </p>
        </div>

        {/* Offerings Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {offerings.map((offering, index) => {
            const IconComponent = offering.icon;
            
            return (
              <div
                key={index}
                className="group relative"
              >
                {/* Card */}
                <div className="relative bg-slate-800/70 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 h-full
                  hover:border-slate-600 hover:bg-slate-800/90 transition-all duration-500
                  hover:shadow-2xl hover:shadow-slate-900/50 hover:-translate-y-2">
                  
                  {/* Gradient line at top */}
                  <div className={`absolute top-0 left-8 right-8 h-1 bg-gradient-to-r ${offering.gradient} rounded-full 
                    transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`} />
                  
                  {/* Icon */}
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${offering.gradient} p-0.5 mb-6
                    group-hover:scale-110 transition-transform duration-300`}>
                    <div className="w-full h-full bg-slate-900 rounded-2xl flex items-center justify-center">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors">
                    {offering.title}
                  </h3>

                  {/* Description */}
                  <p className="text-slate-300 text-lg leading-relaxed mb-6">
                    {offering.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3">
                    {offering.features.map((feature, i) => (
                      <div key={i} className="flex items-center gap-3">
                        <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${offering.gradient}`} />
                        <span className="text-slate-400 text-base group-hover:text-slate-300 transition-colors">
                          {feature}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <a 
            href="#contact"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 
              hover:from-amber-600 hover:to-amber-700 text-slate-900 font-bold text-lg px-8 py-4 rounded-xl 
              transition-all duration-300 shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40"
          >
            Solicită Consultație Gratuită
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default OfferingsSection;
